import { render, staticRenderFns } from "./MeusPromotoresView.vue?vue&type=template&id=baea44fc&scoped=true"
import script from "./MeusPromotoresView.vue?vue&type=script&lang=js"
export * from "./MeusPromotoresView.vue?vue&type=script&lang=js"
import style0 from "./MeusPromotoresView.vue?vue&type=style&index=0&id=baea44fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baea44fc",
  null
  
)

export default component.exports